import { render, staticRenderFns } from "./IconArrowRightSolid.vue?vue&type=template&id=9a9335be"
import script from "./IconArrowRightSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowRightSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports